module.exports = __webpack_public_path__ + "static/threejs-bd4e400c59f6987f8def2fd9bc90590e.png";